"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-undef */
const react_1 = __importStar(require("react"));
const helpers_1 = require("./helpers");
const styled_1 = require("./styled");
const SIMPLEX_SCRIPTS = {
    production: {
        head: "https://cdn.simplex.com/sdk/v1/js/sdk.js",
        body: "https://iframe.simplex-affiliates.com/form-sdk.js",
        key: "pk_live_d8dba7e8-c58e-4f3b-8318-6a0f6ad923af",
    },
    development: {
        head: "https://cdn.test-simplexcc.com/sdk/v1/js/sdk.js",
        body: "https://iframe.sandbox.test-simplexcc.com/form-sdk.js",
        key: "pk_test_cdac5746-fb48-4489-bf18-10fb9028ac90",
    },
};
const SimplexWidget = (_a) => {
    var { feeText, crypto, env, fiat, amount, lang, externalTransactionId, wallet } = _a, rest = __rest(_a, ["feeText", "crypto", "env", "fiat", "amount", "lang", "externalTransactionId", "wallet"]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const simplexRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const loadSimplex = () => __awaiter(void 0, void 0, void 0, function* () {
            /* if (window.simplex && window.simplex.updateCryptoCurrency && crypto) {
              window.simplex.updateCryptoCurrency(crypto.toUpperCase());
      
              return;
            } */
            try {
                const headScript = SIMPLEX_SCRIPTS[env].head;
                const bodyScript = SIMPLEX_SCRIPTS[env].body;
                const pubKey = SIMPLEX_SCRIPTS[env].key;
                window.simplexAsyncFunction = () => {
                    Simplex.init({ public_key: pubKey });
                };
                if (simplexRef === null || simplexRef.current === null)
                    return;
                yield (0, helpers_1.loadHeadScript)(headScript, simplexRef.current);
                yield (0, helpers_1.loadBodyScript)(bodyScript, simplexRef.current);
                yield window.simplex.on("crypto-changed", (currency) => {
                    // eslint-disable-next-line no-console
                    console.log("currency change", currency);
                });
                yield window.simplex.on("onlineFlowFinished", ({ payload }) => {
                    // eslint-disable-next-line no-console
                    console.log("onflowfinished", payload.result);
                    (0, helpers_1.sendGaEvent)({
                        category: "Buy Simplex",
                        label: "onlineFlowFinished",
                        action: payload.result,
                    });
                });
                const newSearch = new URLSearchParams();
                if (window.location.search.includes("widget"))
                    newSearch.append("widget", "");
                if (amount)
                    newSearch.append("amount", amount.toString());
                if (lang)
                    newSearch.append("lang", lang);
                if (externalTransactionId)
                    newSearch.append("ref_id", externalTransactionId);
                if (crypto) {
                    if (crypto === "AVAX") {
                        newSearch.append("crypto", "AVAX-C");
                    }
                    else {
                        newSearch.append("crypto", crypto);
                    }
                }
                if (wallet)
                    newSearch.append("wallet_address", wallet);
                window.history.pushState("string", document.title, `${window.location.origin}${window.location.pathname}?${newSearch}`);
                const data = yield window.simplex.createForm({
                    crypto: crypto === null || crypto === void 0 ? void 0 : crypto.toUpperCase(),
                    fiat: fiat === null || fiat === void 0 ? void 0 : fiat.toUpperCase(),
                    amount: amount || undefined,
                    lang: lang || undefined,
                });
                // eslint-disable-next-line no-console
                console.log(data);
                /* if (crypto) {
                } else {
                  await window.simplex.createForm();
                } */
                setLoading(false);
            }
            catch (err) {
                // eslint-disable-next-line no-console
                console.log("simplex load", err);
                setLoading(false);
                // TODO: Handle error
            }
        });
        if (loading) {
            loadSimplex();
        }
        return () => {
            if (!loading)
                Simplex.unload((evt) => {
                    // eslint-disable-next-line no-console
                    console.log(evt);
                    window.location.reload();
                });
        };
    }, [amount, crypto, env, fiat, lang, loading, externalTransactionId, wallet]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: simplexRef }),
        react_1.default.createElement(styled_1.StyledSimplexForm, Object.assign({ id: "simplex-form" }, rest),
            react_1.default.createElement("div", { id: "checkout-element", style: { height: "100%" } })),
        feeText && react_1.default.createElement(styled_1.FeeText, null, feeText)));
};
exports.default = SimplexWidget;
//# sourceMappingURL=SimplexWidget.js.map